import React, { Children } from 'react';

import {
  arrayOf,
  bool,
  func,
  node,
  oneOf,
  oneOfType,
  shape,
  string
} from 'prop-types';

import ClassNames from 'classnames';

import BaseComponent from '../.internal/BaseComponent';
import Loader from '../loader/Loader';

import './ButtonV2.scss';

const CLASS_TYPES = {
  primary: 'primary',
  secondary: 'secondary',
  tertiary: 'tertiary'
};

const SIZES = ['sm', 'md', 'lg'];

export default class ButtonV2 extends BaseComponent {
  render() {
    const {
      children,
      className,
      disabled,
      id,
      isSubmit,
      loading,
      onBlur,
      onClick,
      onFocus,
      onMouseLeave,
      onMouseOut,
      onMouseOver,
      size,
      style,
      type,
      buttonRef
    } = this.props;

    const wrapTextNode = Children.map(children, child => {
      return typeof child === 'string' ? <span>{child}</span> : child;
    });

    const classNames = ClassNames(
      'button',
      className,
      `button--${CLASS_TYPES[type]}`,
      SIZES.includes(size) && `button--${size}`,
      loading && 'button--loading'
    );

    const loadingSpinnerClassNames = ClassNames(
      'button__loading-spinner',
      loading && 'visible'
    );

    return (
      <button
        className={classNames}
        disabled={disabled || loading}
        id={id}
        onClick={onClick}
        onFocus={onFocus}
        onBlur={onBlur}
        onMouseOut={onMouseOut}
        onMouseOver={onMouseOver}
        onMouseLeave={onMouseLeave}
        style={style}
        ref={buttonRef}
        // Disabling rule here for ESLint doesn't allow
        // button `type` attribute (e.g., "submit", "button")
        // to be dynamic
        // eslint-disable-next-line react/button-has-type
        type={isSubmit ? 'submit' : 'button'}
      >
        <div className="button__content">
          {wrapTextNode}
          {loading && (
            <div className={loadingSpinnerClassNames}>
              <Loader size="sm" />
            </div>
          )}
        </div>
      </button>
    );
  }
}

ButtonV2.propTypes = {
  buttonRef: shape({}),
  children: oneOfType([arrayOf(node), node]).isRequired,
  className: string,
  disabled: bool,
  id: string,
  isSubmit: bool,
  loading: bool,
  onBlur: func,
  onClick: func,
  onFocus: func,
  onMouseLeave: func,
  onMouseOut: func,
  onMouseOver: func,
  size: oneOf(['sm', 'md', 'lg']),
  style: shape({}),
  type: oneOf(['primary', 'secondary', 'tertiary'])
};

ButtonV2.defaultProps = {
  buttonRef: null,
  className: undefined,
  disabled: false,
  id: undefined,
  isSubmit: false,
  loading: false,
  onBlur: undefined,
  onClick: undefined,
  onFocus: undefined,
  onMouseLeave: undefined,
  onMouseOut: undefined,
  onMouseOver: undefined,
  size: 'md',
  style: undefined,
  type: 'primary'
};
